/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Setup_Source_TitleInputs */

const cs_import_setup_source_title = /** @type {(inputs: Import_Setup_Source_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdroj`)
};

const en_import_setup_source_title = /** @type {(inputs: Import_Setup_Source_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

/**
* | output |
* | --- |
* | "Source" |
*
* @param {Import_Setup_Source_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_setup_source_title = /** @type {((inputs?: Import_Setup_Source_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Setup_Source_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_setup_source_title(inputs)
	return cs_import_setup_source_title(inputs)
});